import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';

import { POSITION, STATUS } from '../../config/constants';
import { isBlankString } from '../../helpers/helpers';

import './Entities.scss';

const SelectableField =  ({ content, options, saveClickObserver }: {content:string; options: typeof STATUS | typeof POSITION;  saveClickObserver: (value: any) => void }) => {
  const [selectedOption, setSelectedOption] = useState(content);

  useEffect(() => {
    if (content && !isBlankString(content)) {
      setSelectedOption(content);
    }
  }, [content]);

  useEffect(() => {
    setSelectedOption(content);
  }, []);

  useEffect(() => {
    if (saveClickObserver) {
      saveClickObserver(selectedOption);
    }
  }, [saveClickObserver]);

  const onDropdownSelection = (selectedValue:string) => setSelectedOption(selectedValue);

  const dropdownOptions: JSX.Element[] = [];
  if (options.name === POSITION.name) {
    options.types.forEach((type:typeof STATUS.types[0] | typeof POSITION.types[0], index:number) =>
      dropdownOptions.push(<Dropdown.Item
      //@ts-ignore
                              onSelect={() => onDropdownSelection(type.value.position)}
                              //@ts-ignore
                              active={content === type.value.position}
                              //@ts-ignore
                              key={index}>{type.value.position}</Dropdown.Item>));
  } else {
    options.types.forEach((type:typeof STATUS.types[0] | typeof POSITION.types[0], index:number) =>
      dropdownOptions.push(<Dropdown.Item
                              onSelect={() => onDropdownSelection(type.value as string)}
                              active={content === type.value}
                              key={index}>{type.value}</Dropdown.Item>));
  }
  return (
    <Dropdown className={options.name === POSITION.name ? "select-btn pos-btn" : "select-btn"}>
      <Dropdown.Toggle>
        {!selectedOption || selectedOption === '' || isBlankString(selectedOption) ? 'Select' : selectedOption}
      </Dropdown.Toggle>

      <Dropdown.Menu>
          {dropdownOptions}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SelectableField;
